import { BeltColor, belt } from "./BeltColor"

export function getBeltColor(level: number): BeltColor {
  if (level >= belt.length) {
    return belt[belt.length - 1]
  }
  return belt[level]
}
